import localeAntd from 'ant-design-vue/lib/locale-provider/en_US'

const messages = {
  topBar: {
    issuesHistory: 'Istorija odobrenja',
    projectManagement: 'Izbor kompanije',
    typeToSearch: 'Pretraga...',
    findPages: 'Pronađi strane...',
    actions: 'Opcije',
    status: 'Status',
    profileMenu: {
      hello: 'Zdravo',
      billingPlan: 'Plan pretplate',
      role: 'Dozvole',
      email: 'Email',
      phone: 'Tel',
      editProfile: 'Uredi profil',
      logout: 'Odjava',
    },
  },
}

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}
